import Box from '@mui/material/Box';
import styled from 'styled-components';
import { SIZES } from '@scope/scope-one-ui/theme';
import BarChartIcon from '@mui/icons-material/BarChart';
import { theme } from '../../../theme';

export const Wrapper = styled(Box)`
  position: relative;
  height: ${SIZES.spacing(9.75)};
  border-radius: 6px;
  box-shadow: 0px 3px 6px #00000029;
  color: ${theme.palette.primary.contrastText};
  background-color: ${theme.palette.custom.creditAnalysisEvents};

  img {
    position: absolute;
    opacity: 0.54;
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 6px;
    z-index: 1;
  }
`;

export const BoxStyled = styled(Box)`
  position: relative;
  z-index: 2;
  padding: ${SIZES.spacing(2.375)};
  align-items: center;
  display: flex;
  justify-content: space-between;

  button {
    color: ${theme.palette.primary.contrastText};
    border-color: ${theme.palette.primary.contrastText};

    :hover {
      border-color: ${theme.palette.primary.contrastText};
      background-color: ${theme.palette.primary.contrastText};
      color: ${theme.palette.primary.main};
    }
  }
`;

export const BarChartIconWrapper = styled(Box)`
  width: ${SIZES.spacing(5)};
  height: ${SIZES.spacing(5)};
  border-radius: 50%;
  background-color: ${theme.palette.primary.contrastText};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const BarChartIconStyled = styled(BarChartIcon)`
  color: ${theme.palette.custom.creditAnalysisEvents};
`;
